"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2067],{

/***/ 39789:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88450));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _core = __webpack_require__(79329);
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _excluded = ["sx", "inputRef", "onChange", "onEnter"];
var __jsx = _react["default"].createElement;
/**
 * Input Raw
 */
var inputResetStyles = {
  border: 0,
  bg: "transparent",
  ":invalid": {
    boxShadow: "none",
    outline: "none"
  },
  "::-webkit-outer-spin-button, ::-webkit-inner-spin-button, ::-webkit-search-decoration, ::-webkit-search-cancel-button, ::-webkit-search-results-button, ::-webkit-search-results-decoration": {
    WebkitAppearance: "none"
  },
  WebkitAppearance: "none",
  MozAppearance: "textfield"
};
var InputRaw_ = function InputRaw_(props) {
  var sx = props.sx,
    inputRef = props.inputRef,
    _onChange = props.onChange,
    onEnter = props.onEnter,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _splitSx = (0, _core.splitSx)(sx),
    _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 1),
    css = _splitSx2[0];
  return __jsx(_Box["default"], (0, _extends2["default"])({
    as: "input",
    sx: [inputResetStyles, css],
    onChange: function onChange(event) {
      if (_onChange) {
        _onChange(event.target.value, event);
      }
    },
    onKeyDown: function onKeyDown(event) {
      if (!onEnter) return;
      if (event.key === "Enter") {
        onEnter();
      }
    }
  }, restProps, {
    ref: inputRef
  }));
};
var InputRaw = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return __jsx(InputRaw_, (0, _extends2["default"])({
    inputRef: ref
  }, props));
});
var _default = InputRaw;
exports["default"] = _default;

/***/ }),

/***/ 36642:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _QuantityPicker = __webpack_require__(40753);
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _usePagination = _interopRequireDefault(__webpack_require__(3066));
var _usePaginationLoader2 = __webpack_require__(95514);
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PreviousArrowIcon = function PreviousArrowIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.952 12.748l8.133-8.495-.866-.83-8.92 9.316 8.915 9.51.876-.821-8.138-8.68z"
  }));
};
PreviousArrowIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var NextArrowIcon = function NextArrowIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.436 12.748L7.303 4.253l.867-.83 8.92 9.316-8.916 9.51-.875-.821 8.137-8.68z"
  }));
};
NextArrowIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var Pagination = function Pagination(props) {
  var pagesAmount = props.pagesAmount,
    currentPage = props.currentPage,
    onChange = props.onChange,
    prevButton = props.prevButton,
    nextButton = props.nextButton,
    qtyPicker = props.qtyPicker,
    font = props.font;
  var translations = {
    of: (0, _langLibrary["default"])("of"),
    page: (0, _langLibrary["default"])("page")
  };
  var _usePaginationLoader = (0, _usePaginationLoader2.usePaginationLoader)(),
    isLoading = _usePaginationLoader.isLoading;
  var pagination = (0, _usePagination["default"])({
    count: pagesAmount,
    current: parseInt(currentPage),
    onChange: onChange
  });
  var quantityPicker = (0, _QuantityPicker.useQuantityPicker)({
    defaultValue: currentPage,
    maxValue: pagesAmount,
    label: translations.page,
    onChange: pagination.goTo
  });
  var buttonPrevious = /*#__PURE__*/_react["default"].cloneElement(prevButton, _objectSpread(_objectSpread({}, pagination.prevButtonProps), {}, {
    disabled: isLoading,
    onChange: pagination.goToPrev,
    "data-test": "pagination-prev",
    sx: {
      fill: "active",
      fillOpacity: pagination.prevButtonActive ? "1" : "0.2",
      mr: "s6"
    }
  }), __jsx(PreviousArrowIcon, null));
  var buttonNext = /*#__PURE__*/_react["default"].cloneElement(nextButton, _objectSpread(_objectSpread({}, pagination.nextButtonProps), {}, {
    disabled: isLoading,
    onChange: pagination.goToNext,
    "data-test": "pagination-next",
    sx: {
      fill: "active",
      fillOpacity: pagination.nextButtonActive ? "1" : "0.2",
      ml: "s6"
    }
  }), __jsx(NextArrowIcon, null));
  return pagesAmount > 1 ? __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center"
    }
  }, buttonPrevious, " ", __jsx(_Box["default"], {
    as: "span",
    sx: {
      width: "120px",
      color: "main",
      font: font !== null && font !== void 0 ? font : "base_sans",
      lineHeight: "29px",
      height: "24px",
      display: "flex",
      opacity: isLoading ? ".4" : "1",
      justifyContent: "center"
    }
  }, __jsx(_Box["default"], null, /*#__PURE__*/_react["default"].cloneElement(qtyPicker, {
    controller: quantityPicker
  })), __jsx(_Box["default"], {
    sx: {
      marginLeft: "10px"
    }
  }, translations.of, " ", pagination.count)), " ", buttonNext) : null;
};
var _default = Pagination;
exports.Z = _default;

/***/ }),

/***/ 40753:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useQuantityPicker = exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _objectDestructuringEmpty2 = _interopRequireDefault(__webpack_require__(37739));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _core = __webpack_require__(79329);
var _ButtonRaw = _interopRequireDefault(__webpack_require__(30650));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _SelectNative = _interopRequireDefault(__webpack_require__(20912));
var _InputRaw = _interopRequireDefault(__webpack_require__(39789));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useLayoutEffect = typeof window === "object" ? _react.useLayoutEffect : _react.useEffect;
var defaults = {
  $buttonDecrease: {
    __type: _ButtonRaw["default"],
    __children: "-"
  },
  $buttonIncrease: {
    __type: _ButtonRaw["default"],
    __children: "+"
  },
  $root: function $root(_ref) {
    var focused = _ref.focused;
    return {
      position: "relative",
      display: "inline-flex",
      verticalAlign: "top",
      overflow: "hidden",
      flexDirection: "row"
    };
  },
  $input: function $input(_ref2) {
    (0, _objectDestructuringEmpty2["default"])(_ref2);
    return {
      __type: _InputRaw["default"],
      textAlign: "center"
    };
  },
  $select: function $select() {
    return {
      __type: _SelectNative["default"],
      __props: {
        allowEmpty: false
      }
    };
  }
};
var useQuantityPicker = function useQuantityPicker() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$step = props.step,
    step = _props$step === void 0 ? 1 : _props$step,
    defaultValue = props.defaultValue,
    _props$maxValue = props.maxValue,
    maxValue = _props$maxValue === void 0 ? 999 : _props$maxValue,
    _props$selectOptionsA = props.selectOptionsAmount,
    selectOptionsAmount = _props$selectOptionsA === void 0 ? __webpack_require__.g.__appConfig__.paginationQuantityPickerOptionsNumber - 1 : _props$selectOptionsA,
    onChange = props.onChange,
    _props$label = props.label,
    label = _props$label === void 0 ? "Quantity" : _props$label;
  var _useState = (0, _react.useState)(defaultValue || step),
    amount = _useState[0],
    setAmount = _useState[1];
  var _useState2 = (0, _react.useState)(defaultValue || step),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    inputFocusedAfterSelectingMore = _useState3[0],
    setInputFocusedAfterSelectingMore = _useState3[1];
  (0, _react.useEffect)(function () {
    setAmount(defaultValue);
    setInputValue(defaultValue);
  }, [defaultValue]);
  var inputRef = (0, _react.useRef)(null);
  var setValue = function setValue(number) {
    var newVal = number;
    if (isNaN(newVal)) {
      newVal = defaultValue;
    }
    newVal = Math.max(newVal, step);
    newVal = Math.min(newVal, maxValue);

    // Check if multiple of step
    var rest = newVal % step;
    if (rest != 0) {
      newVal = newVal - rest;
    }
    setAmount(newVal);
    setInputValue(newVal);
    if (newVal !== amount && onChange) {
      onChange(newVal);
    }
  };
  var isMin = amount === step;
  var isMax = amount === maxValue - maxValue % step;
  var buttonIncrementProps = {
    onClick: function onClick() {
      setValue(amount + step);
    },
    disabled: isMax
  };
  var buttonDecrementProps = {
    onClick: function onClick() {
      setValue(amount - step);
    },
    disabled: isMin
  };
  var submitInputValue = function submitInputValue() {
    setValue(parseInt(inputValue));
    setInputFocusedAfterSelectingMore(false);
  };
  var inputProps = {
    value: inputValue,
    onChange: function onChange(val) {
      setInputValue(val);
    },
    onBlur: function onBlur() {
      submitInputValue();
    },
    inputRef: inputRef
  };
  useLayoutEffect(function () {
    if (inputFocusedAfterSelectingMore) {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  });
  var selectOptions = [];
  var maxSelectAmount = selectOptionsAmount * step;
  var moreOption;
  if (maxValue <= __webpack_require__.g.__appConfig__.paginationQuantityPickerOptionsNumber) {
    for (var i = 1; i <= maxValue; i++) {
      selectOptions.push("".concat(i * step));
    }
    maxSelectAmount = maxValue;
  } else {
    for (var _i = 1; _i <= selectOptionsAmount; _i++) {
      selectOptions.push("".concat(_i * step));
    }
    moreOption = "".concat(selectOptionsAmount + step, "+");
    selectOptions.push(moreOption);
  }
  // select

  var exceedsSelectRange = amount > maxSelectAmount || inputFocusedAfterSelectingMore;
  var selectProps = {
    options: selectOptions,
    value: exceedsSelectRange ? moreOption : "".concat(amount),
    onChange: function onChange(val) {
      if (moreOption && val === moreOption) {
        setInputValue("");
        setInputFocusedAfterSelectingMore(true);
      } else {
        setValue(parseInt(val));
      }
    },
    label: label,
    placeholder: label
  };
  var ret = {
    // inputFocusedAfterSelectingMore,
    exceedsSelectRange: exceedsSelectRange,
    buttonIncrementProps: buttonIncrementProps,
    buttonDecrementProps: buttonDecrementProps,
    inputProps: inputProps,
    selectProps: selectProps,
    amount: amount,
    isMax: isMax,
    isMin: isMin,
    setAmount: setValue,
    reset: function reset() {
      setValue(-1);
    }
  };
  return _objectSpread(_objectSpread({}, ret), {}, {
    counterProps: {
      controller: ret
    }
  });
};
exports.useQuantityPicker = useQuantityPicker;
function QuantityPicker$(props) {
  var loading = props.loading;
  var _props$sx = props.sx,
    sx = _props$sx === void 0 ? {} : _props$sx;
  var controller;
  if (props.controller) {
    controller = props.controller;
  } else {
    controller = useQuantityPicker(props);
  }
  var _useState4 = (0, _react.useState)(false),
    focused = _useState4[0],
    setFocused = _useState4[1];
  var state = {
    focused: focused
  };
  sx = typeof sx === "function" ? sx(state) : sx;
  var _splitSx = (0, _core.splitSx)(sx),
    _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
    css = _splitSx2[0],
    customSx = _splitSx2[1];
  var rootCss = typeof customSx.$root === "function" ? customSx.$root(state) : customSx.$root;
  var onFocus = function onFocus(e) {
    // setFocused(true);
  };
  var onBlur = function onBlur(e) {
    setFocused(false);
  };
  var buttonDecrease;
  var buttonIncrease;
  if (customSx.$buttonDecrease !== null) {
    buttonDecrease = (0, _core.createElement)((0, _core.getElementSpec)(customSx.$buttonDecrease, defaults.$buttonDecrease, state, _objectSpread({
      onFocus: onFocus,
      onBlur: onBlur
    }, controller.buttonDecrementProps), "-"));
  }
  if (customSx.$buttonIncrease !== null) {
    buttonIncrease = (0, _core.createElement)((0, _core.getElementSpec)(customSx.$buttonIncrease, defaults.$buttonIncrease, state, _objectSpread({
      onFocus: onFocus,
      onBlur: onBlur
    }, controller.buttonIncrementProps), "+"));
  }
  var input = (0, _core.createElement)((0, _core.getElementSpec)(customSx.$input, defaults.$input, state), _objectSpread({
    type: "number",
    onFocus: onFocus,
    onBlur: onBlur,
    onEnter: controller.inputProps.onBlur
  }, controller.inputProps));
  var select = (0, _core.createElement)((0, _core.getElementSpec)(customSx.$select, defaults.$select, state), _objectSpread(_objectSpread({
    onFocus: onFocus,
    onBlur: onBlur
  }, controller.selectProps), {}, {
    disabled: loading
  }));
  return __jsx(_Box["default"], {
    sx: css
  }, __jsx(_Box["default"], {
    sx: [{
      display: "flex",
      flexDirection: "row"
    }, defaults.$root(state), rootCss]
  }, buttonDecrease, controller.exceedsSelectRange && input, !controller.exceedsSelectRange && select, buttonIncrease));
}
var _default = QuantityPicker$;
exports["default"] = _default;

/***/ }),

/***/ 44014:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(87193));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _InputRaw = _interopRequireDefault(__webpack_require__(38164));
var _QuantityPicker = __webpack_require__(40753);
var _Select2Ui = _interopRequireDefault(__webpack_require__(84807));
var _ButtonMinimalIcon = _interopRequireDefault(__webpack_require__(95574));
var _ItemRow = _interopRequireDefault(__webpack_require__(627));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IconChevronDown = function IconChevronDown(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
IconChevronDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var QuantityPickerSmall = function QuantityPickerSmall(props) {
  var counter = props.controller || (0, _QuantityPicker.useQuantityPicker)(props);
  var ref = (0, _react.useRef)(null);
  var inputsDisplay = {
    select: counter.exceedsSelectRange ? {
      display: "none"
    } : {
      display: "flex"
    },
    input: counter.exceedsSelectRange ? {
      display: "block"
    } : {
      display: "none"
    }
  };
  return __jsx(_Box["default"], {
    sx: {
      height: 28,
      width: "100%",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "neutral",
      borderRadius: 14,
      ":focus-within": {
        borderColor: "main"
      }
    },
    "data-test": "quantity-picker-small",
    _ref: ref
  }, __jsx(_InputRaw["default"], (0, _extends2["default"])({}, counter.inputProps, {
    sx: _objectSpread(_objectSpread({}, inputsDisplay.input), {}, {
      width: 56,
      font: "body2",
      lineHeight: 1,
      minWidth: 50,
      height: 28,
      textAlign: "center",
      color: props.loading ? "beigeDarken" : "black"
    }),
    type: "number",
    noFocus: true,
    onKeyPress: function onKeyPress(event) {
      if ((event === null || event === void 0 ? void 0 : event.charCode) === 13) {
        event.target.blur();
      }
    }
  })), __jsx(_Select2Ui["default"], (0, _extends2["default"])({}, counter.selectProps, {
    button: function button(_ref) {
      var value = _ref.value;
      return __jsx(_ButtonMinimalIcon["default"], {
        sx: _objectSpread(_objectSpread({}, inputsDisplay.select), {}, {
          width: 56,
          font: "body2",
          lineHeight: 1,
          minWidth: 50,
          height: 28,
          color: props.loading ? "neutral" : "black"
        })
      }, __jsx(_Box["default"], {
        sx: {
          width: 56,
          alignItems: "center",
          justifyContent: "flex-end",
          position: "relative",
          textAlign: "right"
        }
      }, __jsx(_Box["default"], {
        sx: {
          width: "100%",
          height: "100%",
          position: "absolute",
          color: "black",
          textAlign: "center",
          pt: 5,
          left: -6
        }
      }, value), __jsx(IconChevronDown, null)));
    },
    selectable: __jsx(_ItemRow["default"], null),
    allowEmpty: false,
    anchoredTo: ["window", null, ref],
    placement: ["center", null, "bottomLeft"],
    width: ["70vw", null, 150],
    root: {
      height: ["70vh", null, 300],
      boxShadow: "0 0px 14px rgba(0, 0, 0, 0.15)",
      bg: "white"
    }
  })));
};
var _default = QuantityPickerSmall;
exports["default"] = _default;

/***/ }),

/***/ 62067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_Pagination__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36642);
/* harmony import */ var _deosite_components_new_buttons_ButtonMinimalIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95574);
/* harmony import */ var _quantityPickers_QuantityPickerSmall__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76203);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Pagination = function(props) {
    var propsExt = _objectSpread({}, props, {
        qtyPicker: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_quantityPickers_QuantityPickerSmall__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_Pagination__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, propsExt, {
        prevButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_ButtonMinimalIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {}),
        nextButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_ButtonMinimalIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {})
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 76203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_quantityPickers_QuantityPickerSmall__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44014);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var QuantityPickerSmall = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_quantityPickers_QuantityPickerSmall__WEBPACK_IMPORTED_MODULE_2__["default"], _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (QuantityPickerSmall);


/***/ })

}]);